export const INSTITUTE_STATUS = ['active', 'inactive'] as const;

export type InstituteStatus = (typeof INSTITUTE_STATUS)[number];

export const DEFAULT_INSTITUTE_PAGE_SIZE = 20;
